import assetUtils from 'app-lib/assetUtils'
import numberUtils from 'app-lib/numberUtils'
import IBorrowInfo from 'bzx-common/src/domain/borrow/IBorrowInfo'
import { IBorrowItem } from 'bzx-common/src/stores/BorrowStore/BorrowStore'
import { Button, Icon, InfoTip } from 'ui-framework'
import { observer } from 'mobx-react'
import React from 'react'
import TokenTip from 'shared-components/TokenTip'
import BorrowAssetVM from './BorrowAssetVM'

const rateFreeTipContent = (
  <div className="txt-explanation padded-1 txt-left">
    <h4 className="h4">Ooki Free borrowing rates?</h4>
    <p>
      It is only when users have borrowed <i>around 80% of the available liquidity or more</i>, that
      borrowing rates increase more.
    </p>
    <p>Of course, once you borrow, the rates will go up accordingly.</p>
    <p>Thanks to Ooki, you can borrow assets at very low rates, sometimes practically for free!</p>
  </div>
)

export function BorrowAssetItem({ vm, item }: { vm: BorrowAssetVM; item: IBorrowItem }) {
  const { chain } = vm.rootStore
  const { asset, interestRate, availableLiquidity } = item
  const { spriteLogo } = assetUtils.getCommon(asset)
  const { isConnected } = vm.rootStore.web3Connection
  const borrowInfo = { asset, interestRate, liquidity: availableLiquidity } as IBorrowInfo
  const isComingSoon = !!(chain && chain.comingSoon.tokens[asset])

  const rateText = interestRate.lt(0.001) ? (
    <span className="txt-positive">
      <b title={interestRate.toFixed() + '%'}>Free</b>{' '}
      <InfoTip id={`lend-apr-tooltip${asset}`} top={-1} delayShow={150}>
        {rateFreeTipContent}
      </InfoTip>
    </span>
  ) : (
    <b title={interestRate.toFixed() + '%'}>{numberUtils.formatPercent(interestRate) + '%'}</b>
  )

  return (
    <div className="panel--simple md-padded-h-2 padded-v-1 margin-bottom-1">
      <div className="borrow-list-item__grid items-center">
        <div className="flex-row-center">
          <Icon name={spriteLogo} size={38} />
          {item.iTokenAddress ? (
            <TokenTip iTokenAddress={item.iTokenAddress} iTokenExplorerUrl={item.iTokenExplorerUrl}>
              <b className="margin-left-05">{asset}</b>
            </TokenTip>
          ) : (
            <b className="margin-left-05">{asset}</b>
          )}
        </div>
        <div className="borrow-list-item__rate">{rateText}</div>
        {isComingSoon ? (
          <div>
            <span className="badge--green">Coming soon!</span>
          </div>
        ) : (
          <div>
            <div>
              <b title={item.availableLiquidity.toFixed()}>
                {numberUtils.abbreviate(item.availableLiquidity)}
              </b>{' '}
              <span className="txt-subtitle">available</span>
            </div>
            <div>
              <b title={item.totalBorrow}>{numberUtils.abbreviate(item.totalBorrow, 4)}</b>{' '}
              <span className="txt-subtitle">borrowed</span>
            </div>
          </div>
        )}

        <div className="flex-row-center items-end justify-end">
          <Button
            variant="blue"
            disabled={isComingSoon || (item.availableLiquidity.isZero() && !vm.borrowStore.pending)}
            className="btn--responsive borrow__btn"
            onClick={isConnected ? () => vm.onOpen(borrowInfo) : vm.rootStore.notifyConnect}>
            Borrow
          </Button>
        </div>
      </div>
    </div>
  )
}

export default observer(BorrowAssetItem)
